import type { CSSProperties, ReactElement, ReactNode } from 'react';

import {
	Tooltip as ArkTooltip,
	type TooltipRootProps as ArkTooltipRootProps,
	Portal
} from '@ark-ui/react';

import { cn } from '../../lib/utils';

type TooltipProps = Omit<ArkTooltipRootProps, 'positioning'> & {
	content: ReactNode;
	children: ReactElement;
	side?: 'top' | 'right' | 'bottom' | 'left';
	sideOffset?: number;
	openDelay?: number;
	closeDelay?: number;
	disabled?: boolean;
	maxWidth?: string;
	className?: string;
};

function Tooltip({
	content,
	children,
	side = 'top',
	sideOffset = 4,
	openDelay = 400,
	closeDelay = 150,
	disabled,
	maxWidth = '360px',
	className,
	...props
}: TooltipProps) {
	if (disabled) return children;

	return (
		<ArkTooltip.Root
			openDelay={openDelay}
			closeDelay={closeDelay}
			positioning={{ placement: side, gutter: sideOffset }}
			{...props}
		>
			<ArkTooltip.Trigger asChild>{children}</ArkTooltip.Trigger>
			<Portal>
				<ArkTooltip.Positioner className="pt-tooltip-positioner">
					<ArkTooltip.Content
						className={cn('pt-tooltip', className)}
						style={{ '--tooltip-max-width': maxWidth } as CSSProperties}
					>
						{content}
					</ArkTooltip.Content>
				</ArkTooltip.Positioner>
			</Portal>
		</ArkTooltip.Root>
	);
}

export { Tooltip, type TooltipProps };
